export default __webpack_public_path__ + "static/media/icono-4.c3078755.jpg";